(() => {
  const root = document.documentElement;
  const storageKey = 'wgp-color-mode';
  const defaultMode = root.dataset.wgpThemeDefault || 'system';
  const media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

  const readSavedMode = () => {
    try {
      const value = localStorage.getItem(storageKey);
      return value === 'light' || value === 'dark' ? value : null;
    } catch (error) {
      return null;
    }
  };

  const writeSavedMode = (mode) => {
    try {
      localStorage.setItem(storageKey, mode);
    } catch (error) {
      // Storage can be unavailable in privacy-restricted contexts.
      // The switch still works for the current page.
    }
  };

  const getSystemMode = () => media && media.matches ? 'dark' : 'light';

  const getInitialMode = () => {
    const saved = readSavedMode();
    if (saved) return saved;
    if (defaultMode === 'light' || defaultMode === 'dark') return defaultMode;
    return getSystemMode();
  };

  const updateToggles = (mode) => {
    document.querySelectorAll('[data-wgp-theme-toggle]').forEach((button) => {
      const isDark = mode === 'dark';
      const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
      button.setAttribute('aria-checked', String(isDark));
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
      const hiddenLabel = button.querySelector('[data-wgp-theme-label]');
      if (hiddenLabel) hiddenLabel.textContent = label;
    });
  };

  const updateBrowserThemeColor = (mode) => {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    meta.setAttribute('content', mode === 'dark' ? '#1b2529' : '#f9f7f6');
  };

  const applyMode = (mode, persist = false) => {
    root.dataset.wgpTheme = mode;
    root.style.colorScheme = mode;
    if (persist) writeSavedMode(mode);
    updateToggles(mode);
    updateBrowserThemeColor(mode);
    window.dispatchEvent(new CustomEvent('wgp:colormodechange', { detail: { mode } }));
  };

  // theme.liquid sets the initial state before CSS loads to prevent a light-mode flash.
  applyMode(root.dataset.wgpTheme || getInitialMode(), false);

  // Ignite's HeaderDrawer binds a close action directly to buttons inside the drawer.
  // Handle the appearance switch during capture and stop the click before it reaches
  // that drawer handler so changing color mode never closes the sidebar.
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-wgp-theme-toggle]');
    if (!toggle) return;

    event.stopPropagation();

    const nextMode = root.dataset.wgpTheme === 'dark' ? 'light' : 'dark';
    applyMode(nextMode, true);
  }, true);

  // Re-sync the drawer control when Shopify reloads a section in the theme editor.
  document.addEventListener('shopify:section:load', () => updateToggles(root.dataset.wgpTheme || 'light'));

  // Follow the OS only until the visitor explicitly uses the switch.
  const systemChanged = (event) => {
    if (defaultMode !== 'system' || readSavedMode()) return;
    applyMode(event.matches ? 'dark' : 'light', false);
  };

  if (media) {
    if (media.addEventListener) media.addEventListener('change', systemChanged);
    else if (media.addListener) media.addListener(systemChanged);
  }

  requestAnimationFrame(() => root.classList.add('wgp-theme-ready'));
})();
